module.exports = __webpack_public_path__ + "72e1545663849533b31fa2c540db67b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/hong_kong.jpg
// module id = 598
// module chunks = 0